module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-xs col-sm-2"
  }, [_c('nav-links', {
    staticClass: "footer"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_vm._v("For over " + _vm._s(_vm.yearsInBusiness) + " years, we’ve been providing digital design and development services.\n           and brands like MTV, ESPN, Konami, and Turner Broadcasting.")]), _vm._v(" "), _c('p', [_vm._v("\n          Our goal is simple: Exceed our clients’ expectations and make them look like rock stars. No matter what the scope or deadline is, we’re up\n          for the challenge! We always meet deadlines and we aim to impress at every stage of your project.\n        ")]), _vm._v(" "), _c('p', [_vm._v("Please call us to discuss your next project.")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('small', [_vm._v("© " + _vm._s(_vm.currentYear) + " L4B3L, LLC. All Rights Reserved.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 col-sm-offset-1"
  }, [_c('ul', [_c('li', [_vm._v("Connect with us.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tel:8603503800"
    }
  }, [_vm._v("P: 860-350-3800")])])]), _vm._v(" "), _c('address', [_c('div', [_vm._v("33 Bullet Hill Road, Suite 212")]), _vm._v(" "), _c('div', [_vm._v("Southbury, CT 06488")])]), _vm._v(" "), _c('ul', {
    staticClass: "social-media"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Label-Interactive-131941363541204/?fref=ts"
    }
  }, [_c('img', {
    staticClass: "fb-icon",
    attrs: {
      "src": require("assets/images/icon_fb@2x.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d5f12030!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 593
// module chunks = 2